import { useInstance } from '../../support/ioc/useInstance';
import { RoundIconButton } from '../../components/button/RoundIconButton.tsx';
import { AddIcon } from '../../components/icons/Icons.tsx';
import { MapViewModel } from '../model/MapViewModel.ts';

export const ZoomInButton: React.FC = () => {

    const mapVM = useInstance(MapViewModel);

    const zoomIn = () => {
        // if we're already at max zoom, setZoom will do nothing
        mapVM.setZoom(mapVM.getZoom() + 1);
    };

    return (
        <RoundIconButton Icon={AddIcon} onClick={zoomIn} />
    );
};
